/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminEnrollmentDayDetailDTO,
  AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams,
  AdminEnrollmentDayListItemDTOQueryResultDTO,
  UpsertAdminEnrollmentDayDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminEnrollmentDayGetEnrollmentDaysForOrganization = (
    organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminEnrollmentDayListItemDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getAdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryKey = (organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryKey(organizationId,semesterId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>> = ({ signal }) => adminEnrollmentDayGetEnrollmentDaysForOrganization(organizationId,semesterId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && semesterId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>>
export type AdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryError = ErrorType<unknown>


export function useAdminEnrollmentDayGetEnrollmentDaysForOrganization<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params: undefined |  AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminEnrollmentDayGetEnrollmentDaysForOrganization<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminEnrollmentDayGetEnrollmentDaysForOrganization<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminEnrollmentDayGetEnrollmentDaysForOrganization<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    params?: AdminEnrollmentDayGetEnrollmentDaysForOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminEnrollmentDayGetEnrollmentDaysForOrganizationQueryOptions(organizationId,semesterId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminEnrollmentDayClearEnrollmentDaysForSemester = (
    organizationId: number,
    semesterId: number,
 ) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}`, method: 'DELETE'
    },
      );
    }
  


export const getAdminEnrollmentDayClearEnrollmentDaysForSemesterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>, TError,{organizationId: number;semesterId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>, TError,{organizationId: number;semesterId: number}, TContext> => {
    
const mutationKey = ['adminEnrollmentDayClearEnrollmentDaysForSemester'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>, {organizationId: number;semesterId: number}> = (props) => {
          const {organizationId,semesterId} = props ?? {};

          return  adminEnrollmentDayClearEnrollmentDaysForSemester(organizationId,semesterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminEnrollmentDayClearEnrollmentDaysForSemesterMutationResult = NonNullable<Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>>
    
    export type AdminEnrollmentDayClearEnrollmentDaysForSemesterMutationError = ErrorType<unknown>

    export const useAdminEnrollmentDayClearEnrollmentDaysForSemester = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>, TError,{organizationId: number;semesterId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminEnrollmentDayClearEnrollmentDaysForSemester>>,
        TError,
        {organizationId: number;semesterId: number},
        TContext
      > => {

      const mutationOptions = getAdminEnrollmentDayClearEnrollmentDaysForSemesterMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminEnrollmentDayRunEnrollmentDayAssignment = (
    organizationId: number,
    semesterId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}`, method: 'POST', signal
    },
      );
    }
  


export const getAdminEnrollmentDayRunEnrollmentDayAssignmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>, TError,{organizationId: number;semesterId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>, TError,{organizationId: number;semesterId: number}, TContext> => {
    
const mutationKey = ['adminEnrollmentDayRunEnrollmentDayAssignment'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>, {organizationId: number;semesterId: number}> = (props) => {
          const {organizationId,semesterId} = props ?? {};

          return  adminEnrollmentDayRunEnrollmentDayAssignment(organizationId,semesterId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminEnrollmentDayRunEnrollmentDayAssignmentMutationResult = NonNullable<Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>>
    
    export type AdminEnrollmentDayRunEnrollmentDayAssignmentMutationError = ErrorType<unknown>

    export const useAdminEnrollmentDayRunEnrollmentDayAssignment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>, TError,{organizationId: number;semesterId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminEnrollmentDayRunEnrollmentDayAssignment>>,
        TError,
        {organizationId: number;semesterId: number},
        TContext
      > => {

      const mutationOptions = getAdminEnrollmentDayRunEnrollmentDayAssignmentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const adminEnrollmentDayGetEnrollmentDaysForStudent = (
    organizationId: number,
    semesterId: number,
    studentId: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminEnrollmentDayDetailDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}/${studentId}`, method: 'GET', signal
    },
      );
    }
  

export const getAdminEnrollmentDayGetEnrollmentDaysForStudentQueryKey = (organizationId: number,
    semesterId: number,
    studentId: number,) => {
    return [`/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}/${studentId}`] as const;
    }

    
export const getAdminEnrollmentDayGetEnrollmentDaysForStudentQueryOptions = <TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError = ErrorType<unknown>>(organizationId: number,
    semesterId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminEnrollmentDayGetEnrollmentDaysForStudentQueryKey(organizationId,semesterId,studentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>> = ({ signal }) => adminEnrollmentDayGetEnrollmentDaysForStudent(organizationId,semesterId,studentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId && semesterId && studentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminEnrollmentDayGetEnrollmentDaysForStudentQueryResult = NonNullable<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>>
export type AdminEnrollmentDayGetEnrollmentDaysForStudentQueryError = ErrorType<unknown>


export function useAdminEnrollmentDayGetEnrollmentDaysForStudent<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    studentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>,
          TError,
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminEnrollmentDayGetEnrollmentDaysForStudent<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>,
          TError,
          Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminEnrollmentDayGetEnrollmentDaysForStudent<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminEnrollmentDayGetEnrollmentDaysForStudent<TData = Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError = ErrorType<unknown>>(
 organizationId: number,
    semesterId: number,
    studentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminEnrollmentDayGetEnrollmentDaysForStudent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminEnrollmentDayGetEnrollmentDaysForStudentQueryOptions(organizationId,semesterId,studentId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const adminEnrollmentDayUpdateEnrollmentDaysForStudent = (
    organizationId: number,
    semesterId: number,
    studentId: number,
    upsertAdminEnrollmentDayDTO: UpsertAdminEnrollmentDayDTO[],
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/organizations/${organizationId}/admin/AdminEnrollmentDay/${semesterId}/${studentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: upsertAdminEnrollmentDayDTO
    },
      );
    }
  


export const getAdminEnrollmentDayUpdateEnrollmentDaysForStudentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>, TError,{organizationId: number;semesterId: number;studentId: number;data: UpsertAdminEnrollmentDayDTO[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>, TError,{organizationId: number;semesterId: number;studentId: number;data: UpsertAdminEnrollmentDayDTO[]}, TContext> => {
    
const mutationKey = ['adminEnrollmentDayUpdateEnrollmentDaysForStudent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>, {organizationId: number;semesterId: number;studentId: number;data: UpsertAdminEnrollmentDayDTO[]}> = (props) => {
          const {organizationId,semesterId,studentId,data} = props ?? {};

          return  adminEnrollmentDayUpdateEnrollmentDaysForStudent(organizationId,semesterId,studentId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminEnrollmentDayUpdateEnrollmentDaysForStudentMutationResult = NonNullable<Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>>
    export type AdminEnrollmentDayUpdateEnrollmentDaysForStudentMutationBody = UpsertAdminEnrollmentDayDTO[]
    export type AdminEnrollmentDayUpdateEnrollmentDaysForStudentMutationError = ErrorType<unknown>

    export const useAdminEnrollmentDayUpdateEnrollmentDaysForStudent = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>, TError,{organizationId: number;semesterId: number;studentId: number;data: UpsertAdminEnrollmentDayDTO[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminEnrollmentDayUpdateEnrollmentDaysForStudent>>,
        TError,
        {organizationId: number;semesterId: number;studentId: number;data: UpsertAdminEnrollmentDayDTO[]},
        TContext
      > => {

      const mutationOptions = getAdminEnrollmentDayUpdateEnrollmentDaysForStudentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    